module.exports = __webpack_public_path__ + "img/workforce_obrero.b12a304a.png";